
























































































































































































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import HydrationGuard from "@/mixins/HydrationGuard";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import RpdDewasaSvc from "@/services/RpdDewasaService";
import FormPrefillService from "@/services/FormPrefillService";
import { tanganiGagalJaringan } from "@/utils/gagalJaringan";

@Component
export default class CardRiwayatPenyakitTerdahulu extends Mixins(HydrationGuard) {
  @Prop() readonly register!: number | string;
  @Prop() readonly rm!: number | string;
  @Prop({ default: false }) readonly readOnly!: boolean;
  @Prop({ default: false }) readonly isActive!: boolean;
  @Prop({ default: "asesmen_awal_ranap_medis" }) readonly prefillFormKey!: string;

  masters: any = { quick_pick: [], options: {} };
  rpd: any = this.emptyRpd();
  saving = false;
  loadingRiwayat = false;
  icdItemsByKey: any = {};
  obatItemsByKey: any = {};
  private searchTimers: any = {};
  private uidSeq = 0;
  dirty = false;
  // Pemuatan gagal karena jaringan → form dikunci; lihat `muatRecord()`.
  gagalMuat = false;
  private _suspendDirty = false;
  private _sumberTerakhir: string[] = [];

  emptyRpd() {
    return {
      id: null,
      status_rpd: "tidak_ada",
      alasan_unk: null,
      sumber_informasi: ["autoanamnesis"],
      entries: []
    };
  }

  get terkunci(): boolean {
    return this.busy || this.saving;
  }

  get formTerkunci(): boolean {
    return this.readOnly || this.terkunci || this.gagalMuat;
  }

  get rpdId() {
    return this.rpd && this.rpd.id ? this.rpd.id : null;
  }

  get quickPick() {
    return this.masters && this.masters.quick_pick ? this.masters.quick_pick : [];
  }

  get todayIso() {
    return localISODate();
  }

  get todayYear() {
    return new Date().getFullYear();
  }

  get stateUser() {
    return userModule.user;
  }

  get duplicateWarning(): string | null {
    if (this.rpd.status_rpd !== "ada") return null;
    const seen: any = {};
    for (const e of this.rpd.entries) {
      if (e.icd10_code) {
        if (seen[e.icd10_code]) {
          return `Kode ICD-10 ${e.icd10_code} muncul lebih dari sekali.`;
        }
        seen[e.icd10_code] = true;
      }
    }
    return null;
  }

  opt(key: string) {
    return this.masters && this.masters.options && this.masters.options[key]
      ? this.masters.options[key]
      : [];
  }

  nextKey() {
    return ++this.uidSeq;
  }

  seedItems(map: any, key: any, sel: any) {
    this.$set(map, key, sel ? [sel] : []);
  }

  setItems(map: any, key: any, items: any[], sel: any) {
    const list = items || [];
    const withSel =
      sel && !list.some((i: any) => i.label === sel.label)
        ? [sel].concat(list)
        : list;
    this.$set(map, key, withSel);
  }

  async mounted() {
    await this.hydrate(async () => {
      try {
        const m = await RpdDewasaSvc.getMasters();
        this.masters = m.data.data || { quick_pick: [], options: {} };
      } catch {
        //
      }
      await this.muatRecord();
    });
  }

  @Watch("register")
  onRegisterChange() {
    this.loaded = false;
    this.load();
  }

  @Watch("isActive")
  onActiveChange(val: boolean) {
    if (val && !this.dirty && !this.busy) {
      this.load();
    }
  }

  @Watch("rpd", { deep: true })
  onRpdMutated() {
    if (!this._suspendDirty) {
      this.dirty = true;
    }
  }

  async load() {
    await this.hydrate(() => this.muatRecord());
  }

  private async muatRecord() {
    if (!this.register) return;

    const reg = this.register;
    this.gagalMuat = false;

    try {
      const res = await RpdDewasaSvc.getByRegister(reg);
      if (reg !== this.register) return;
      const data = res.data.data;
      this.setRpd(data ? this.bentukRpd(data) : this.emptyRpd());
    } catch (err) {
      if (reg !== this.register) return;

      // Server tidak menjawab → kita TIDAK tahu apakah pasien punya RPD.
      // Menyodorkan form kosong yang bisa disimpan berbahaya: `store()` di
      // server memakai `updateOrCreate` per register, jadi simpan dari form
      // kosong akan MENGHAPUS entry yang sudah tersimpan. Form dikunci lewat
      // flag `gagalMuat` — BUKAN `loaded`, yang selalu di-set true oleh
      // `finally` di HydrationGuard.hydrate(). Dokter dapat mencoba lagi
      // dengan berpindah tab lalu kembali (`@Watch("isActive")` → `load()`).
      if (
        tanganiGagalJaringan(
          err,
          "Riwayat penyakit terdahulu gagal dimuat karena koneksi ke server " +
            "bermasalah. Untuk mencegah data yang sudah tersimpan tertimpa, " +
            "form dikunci — buka ulang tab ini setelah koneksi pulih."
        )
      ) {
        this.gagalMuat = true;
        return;
      }

      this.setRpd(this.emptyRpd());
    }
  }

  setRpd(val: any) {
    this._suspendDirty = true;
    this.rpd = val;
    this._sumberTerakhir = ((val && val.sumber_informasi) || []).slice();
    this.dirty = false;
    this.$nextTick(() => {
      this._suspendDirty = false;
    });
  }

  bentukRpd(data: any) {
    const entries = (data.entries || []).map((e: any) => {
      const entryKey = this.nextKey();
      const icdSel = this.icdOption(e.icd10_code, e.icd10_display);
      this.seedItems(this.icdItemsByKey, entryKey, icdSel);

      return {
        ...e,
        _k: entryKey,
        _icdSelected: icdSel,
        _icdLoading: false,
        _onsetMonth: this.deriveMonth(e),
        _onsetYear: this.deriveYear(e),
        _onsetWarning: null,
        obat: (e.obat || []).map((o: any) => {
          const obatKey = this.nextKey();
          const obatSel = this.obatOption(o.obat_kode, o.nama_generik);
          this.seedItems(this.obatItemsByKey, obatKey, obatSel);

          return {
            ...o,
            _k: obatKey,
            _obatSelected: obatSel,
            _obatLoading: false
          };
        })
      };
    });
    return {
      id: data.id,
      status_rpd: data.status_rpd || "tidak_ada",
      alasan_unk: data.alasan_unk || null,
      sumber_informasi: this.normalizeSumber(data.sumber_informasi),
      entries
    };
  }

  normalizeSumber(val: any): string[] {
    if (Array.isArray(val)) {
      return val.filter((v: any) => !!v).map((v: any) => String(v));
    }
    if (typeof val === "string") {
      const s = val.trim();
      if (!s) return [];
      if (s.charAt(0) === "[") {
        try {
          const parsed = JSON.parse(s);
          return Array.isArray(parsed) ? parsed.map((v: any) => String(v)) : [];
        } catch {
          return [];
        }
      }
      return [s];
    }
    return [];
  }

  deriveMonth(e: any) {
    if (e.onset_mode === "bulan_tahun" && e.onset_date) {
      return String(e.onset_date).substr(0, 7);
    }
    return null;
  }

  deriveYear(e: any) {
    if (e.onset_mode === "tahun_saja" && e.onset_date) {
      return String(e.onset_date).substr(0, 4);
    }
    return null;
  }

  onStatusChange() {
    if (this.rpd.status_rpd !== "ada") {
      this.rpd.entries = [];
    }
    if (this.rpd.status_rpd !== "tidak_diketahui") {
      this.rpd.alasan_unk = null;
    }
  }

  onSumberChange(val: string[]) {
    const baru: string[] = Array.isArray(val) ? val : [];
    const adaSekarang = baru.indexOf("rm_lama") >= 0;
    const adaSebelumnya = this._sumberTerakhir.indexOf("rm_lama") >= 0;
    this._sumberTerakhir = baru.slice();
    if (adaSekarang && !adaSebelumnya) {
      this.loadRiwayatRmLama();
    }
  }

  async pickRmLama() {
    if (this.formTerkunci || this.loadingRiwayat) return;
    const cur: string[] = (this.rpd.sumber_informasi || []).slice();
    if (cur.indexOf("rm_lama") < 0) {
      cur.push("rm_lama");
      this.rpd.sumber_informasi = cur;
    }
    this._sumberTerakhir = cur.slice();
    await this.loadRiwayatRmLama();
  }

  async loadRiwayatRmLama() {
    if (!this.rm || this.loadingRiwayat || this.formTerkunci) return;
    const reg = this.register;
    this.loadingRiwayat = true;
    try {
      const payload = await FormPrefillService.fetchPrefill(
        String(this.rm),
        this.prefillFormKey,
        {
          register_id: this.register,
          unit_id: this.stateUser ? this.stateUser.unit_id : undefined,
          sources: ["riwayat_pasien"]
        }
      );
      if (reg !== this.register) return;

      const list =
        payload && payload.fields ? payload.fields["riwayat.rpd_list"] || [] : [];

      if (!list.length) {
        appModule.sendSuccessNotice(
          "Tidak ada riwayat diagnosis pada rekam medis lama."
        );
        return;
      }

      const existing: any = {};
      for (const e of this.rpd.entries) {
        if (e.icd10_code) existing[e.icd10_code] = true;
      }

      let added = 0;
      for (const item of list) {
        if (!item || !item.kode || existing[item.kode]) continue;
        this.rpd.entries.push(this.entryFromRiwayat(item));
        existing[item.kode] = true;
        added++;
      }

      if (added > 0) {
        this.rpd.status_rpd = "ada";
        appModule.sendSuccessNotice(
          added + " diagnosis dimuat dari rekam medis lama."
        );
      } else {
        appModule.sendSuccessNotice(
          "Riwayat dari rekam medis lama sudah tercantum semua."
        );
      }
    } catch {
      // best-effort — jangan blokir form
    } finally {
      this.loadingRiwayat = false;
    }
  }

  entryFromRiwayat(item: any) {
    const entry = this.emptyEntry();
    entry.icd10_code = item.kode;
    entry.icd10_display = item.nama || item.value || item.kode;
    entry._icdSelected = this.icdOption(entry.icd10_code, entry.icd10_display);
    this.seedItems(this.icdItemsByKey, entry._k, entry._icdSelected);
    // Bersumber dari rekam medis terdokumentasi → terkonfirmasi.
    entry.verification_status = "confirmed";
    entry.clinical_status = "active";
    entry.catatan = item.label || null;

    // Onset dari tanggal tercatat terakhir (perkiraan; user dapat mengoreksi).
    const year = this.parseYear(item.last_tgl || item.recorded_at);
    if (year) {
      entry.onset_mode = "tahun_saja";
      entry._onsetYear = String(year);
      entry.onset_date = year + "-01-01";
    } else {
      entry.onset_mode = "narasi_durasi";
      entry.onset_string = "(dari rekam medis lama)";
    }
    return entry;
  }

  parseYear(val: any): number | null {
    if (!val) return null;
    const m = String(val).match(/(\d{4})/);
    if (!m) return null;
    const y = parseInt(m[1], 10);
    if (y < 1900 || y > this.todayYear) return null;
    return y;
  }

  emptyEntry() {
    const key = this.nextKey();
    this.seedItems(this.icdItemsByKey, key, null);
    return {
      _k: key,
      icd10_code: null,
      icd10_display: null,
      snomed_code: null,
      snomed_display: null,
      onset_mode: "tidak_diketahui",
      onset_date: null,
      onset_age_value: null,
      onset_string: null,
      abatement_date: null,
      clinical_status: "tidak_diketahui",
      verification_status: "unconfirmed",
      severity: null,
      catatan: null,
      obat: [],
      _icdSelected: null,
      _icdLoading: false,
      _onsetMonth: null,
      _onsetYear: null,
      _onsetWarning: null
    };
  }

  addEntry() {
    this.rpd.entries.push(this.emptyEntry());
  }

  removeEntry(i: number) {
    const entry = this.rpd.entries[i];
    if (entry) {
      (entry.obat || []).forEach((o: any) => this.forgetRow(this.obatItemsByKey, o._k));
      this.forgetRow(this.icdItemsByKey, entry._k);
    }
    this.rpd.entries.splice(i, 1);
  }

  forgetRow(map: any, key: any) {
    clearTimeout(this.searchTimers[key]);
    delete this.searchTimers[key];
    this.$delete(map, key);
  }

  addFromQuickPick(q: any) {
    const entry = this.emptyEntry();
    entry.icd10_code = q.icd10;
    entry.icd10_display = q.display;
    entry.snomed_code = q.snomed || null;
    entry._icdSelected = this.icdOption(q.icd10, q.display);
    this.seedItems(this.icdItemsByKey, entry._k, entry._icdSelected);
    this.rpd.entries.push(entry);
  }

  // ── ICD search ──────────────────────────────────────────
  /**
   * Bentuk opsi senada hasil /referensi/diagnosis-icd/search agar v-autocomplete
   * bisa menampilkan penyakit yang di-set programatik (quick-pick, RM lama, hidrasi).
   */
  icdOption(code: string, display: string) {
    if (!code) return null;
    return { label: code + " || " + display, value: code, dx: display, kddx: code };
  }

  onIcdSearch(entry: any, val: string) {
    // Setelah memilih, Vuetify mengisi search-input dgn label pilihan — jangan
    // dijadikan kata kunci pencarian baru. Guard mendahului `clearTimeout`
    // dengan alasan yang sama seperti onObatSearch.
    if (entry._icdSelected && val === entry._icdSelected.label) return;
    if (!val || val.length < 2) return;
    const key = entry._k;
    clearTimeout(this.searchTimers[key]);
    entry._icdLoading = true;
    this.searchTimers[key] = setTimeout(async () => {
      try {
        const res = await RpdDewasaSvc.searchIcd(val);
        this.setItems(this.icdItemsByKey, key, res.data || [], entry._icdSelected);
      } catch {
        this.setItems(this.icdItemsByKey, key, [], entry._icdSelected);
      } finally {
        entry._icdLoading = false;
      }
    }, 450);
  }

  onIcdSelect(entry: any, sel: any) {
    if (!sel) return;
    // format search referensi: { label, value(kode), dx(nama), kddx(kode) }
    entry.icd10_code = sel.value || sel.kddx || null;
    entry.icd10_display = sel.dx || sel.label || null;
  }

  // ── Onset helpers ───────────────────────────────────────
  onOnsetModeChange(entry: any) {
    entry.onset_date = null;
    entry.onset_age_value = null;
    entry.onset_string = null;
    entry._onsetMonth = null;
    entry._onsetYear = null;
    entry._onsetWarning = null;
  }

  onMonthInput(entry: any) {
    // input type=month → YYYY-MM → simpan sbg tanggal awal bulan
    entry.onset_date = entry._onsetMonth ? entry._onsetMonth + "-01" : null;
    this.checkOnset(entry);
  }

  onYearInput(entry: any) {
    entry.onset_date = entry._onsetYear ? entry._onsetYear + "-01-01" : null;
    this.checkOnset(entry);
  }

  checkOnset(entry: any) {
    entry._onsetWarning = null;
    if (entry.onset_date && entry.onset_date > this.todayIso) {
      entry._onsetWarning = "Tanggal onset tidak boleh di masa depan.";
    }
  }

  // ── Obat ────────────────────────────────────────────────
  addObat(entry: any) {
    if (!entry.obat) this.$set(entry, "obat", []);
    const key = this.nextKey();
    this.seedItems(this.obatItemsByKey, key, null);
    entry.obat.push({
      _k: key,
      kfa_code: null,
      obat_kode: null,
      nama_generik: null,
      nama_dagang: null,
      dosis: null,
      frekuensi: null,
      rute: null,
      medication_status: "active",
      effective_start: null,
      effective_end: null,
      adherence: null,
      catatan: null,
      _obatSelected: null,
      _obatLoading: false
    });
  }

  removeObat(entry: any, i: number) {
    const obat = entry.obat[i];
    if (obat) this.forgetRow(this.obatItemsByKey, obat._k);
    entry.obat.splice(i, 1);
  }

  obatOption(kode: any, nama: string) {
    if (!nama) return null;
    return { label: nama, nama, id: kode };
  }

  onObatSearch(obat: any, val: string) {
    if (obat._obatSelected && val === obat._obatSelected.label) return;
    if (!val || val.length < 3) return;
    const key = obat._k;
    clearTimeout(this.searchTimers[key]);
    obat._obatLoading = true;
    this.searchTimers[key] = setTimeout(async () => {
      try {
        const res = await RpdDewasaSvc.searchObat(val);
        this.setItems(this.obatItemsByKey, key, res.data || [], obat._obatSelected);
      } catch {
        this.setItems(this.obatItemsByKey, key, [], obat._obatSelected);
      } finally {
        obat._obatLoading = false;
      }
    }, 450);
  }

  onObatSelect(obat: any, sel: any) {
    if (!sel) return;
    // format /referensi/obat/search: { label, nama, id(KODE), satuan, harga }
    obat.nama_generik = sel.nama || sel.label || null;
    obat.obat_kode = sel.id || null;
  }

  // ── Save ────────────────────────────────────────────────
  buildPayload() {
    const entries =
      this.rpd.status_rpd === "ada"
        ? this.rpd.entries.map((e: any) => ({
            icd10_code: e.icd10_code,
            icd10_display: e.icd10_display,
            snomed_code: e.snomed_code,
            snomed_display: e.snomed_display,
            onset_mode: e.onset_mode,
            onset_date: e.onset_date,
            onset_age_value: e.onset_age_value,
            onset_string: e.onset_string,
            abatement_date: e.abatement_date,
            clinical_status: e.clinical_status,
            verification_status: e.verification_status,
            severity: e.severity,
            catatan: e.catatan,
            obat: (e.obat || []).map((o: any) => ({
              kfa_code: o.kfa_code,
              obat_kode: o.obat_kode,
              nama_generik: o.nama_generik,
              nama_dagang: o.nama_dagang,
              dosis: o.dosis,
              frekuensi: o.frekuensi,
              rute: o.rute,
              medication_status: o.medication_status,
              effective_start: o.effective_start,
              effective_end: o.effective_end,
              adherence: o.adherence,
              catatan: o.catatan
            }))
          }))
        : [];

    return {
      register_id: this.register,
      pasien_rm: this.rm,
      unit_id: this.stateUser ? this.stateUser.unit_id : null,
      status_rpd: this.rpd.status_rpd,
      alasan_unk: this.rpd.alasan_unk,
      sumber_informasi: (this.rpd.sumber_informasi || []).slice(),
      dokter_id: this.stateUser ? this.stateUser.id : null,
      entries
    };
  }

  cekIsian(): string | null {
    if (!this.rpd.sumber_informasi || !this.rpd.sumber_informasi.length) {
      return "Pilih minimal satu Sumber Informasi.";
    }
    if (this.rpd.status_rpd === "tidak_diketahui" && !this.rpd.alasan_unk) {
      return 'Pilih Alasan Tidak Diketahui.';
    }
    if (this.rpd.status_rpd !== "ada") return null;
    if (!this.rpd.entries.length) {
      return 'Tambahkan minimal 1 penyakit, atau pilih "Tidak Ada Riwayat Penyakit Terdahulu".';
    }
    const onsetLabel = {
      tanggal_pasti: "Tanggal onset",
      bulan_tahun: "Bulan/Tahun onset",
      tahun_saja: "Tahun onset"
    };
    for (let i = 0; i < this.rpd.entries.length; i++) {
      const e = this.rpd.entries[i];
      const p = `Penyakit #${i + 1}: `;
      if (!e.icd10_code) return `${p}pilih Jenis Penyakit (ICD-10) dari daftar.`;
      if (onsetLabel[e.onset_mode] && !e.onset_date) {
        return `${p}isi ${onsetLabel[e.onset_mode]}.`;
      }
      if (e.onset_mode === "usia_pasien" && !e.onset_age_value) {
        return `${p}isi Usia saat onset.`;
      }
      if (e.onset_mode === "narasi_durasi" && !e.onset_string) {
        return `${p}isi Durasi onset.`;
      }
      const obat = e.obat || [];
      for (let j = 0; j < obat.length; j++) {
        if (!obat[j].nama_generik) {
          return p + `Obat #${j + 1} — isi Nama Obat atau hapus barisnya.`;
        }
      }
    }
    return null;
  }

  async save() {
    if (this.formTerkunci) return;

    const pesan = this.cekIsian();
    if (pesan) {
      appModule.sendErrorAlert(pesan);
      return;
    }
    const reg = this.register;
    this.saving = true;
    try {
      const payload = this.buildPayload();
      let res: any;

      // Try/catch terpisah supaya deteksi kegagalan jaringan hanya mencakup
      // batas request. Error dari pengolahan respons di bawah juga tidak punya
      // `response` dan akan salah dilaporkan sebagai masalah koneksi.
      try {
        if (this.rpd.id) {
          res = await RpdDewasaSvc.update(this.rpd.id, payload);
        } else {
          res = await RpdDewasaSvc.create(payload);
        }
      } catch (err) {
        // Error ber-`response` (422/500/…) sudah ditampilkan ErrorAlert apa adanya.
        tanganiGagalJaringan(err);
        return;
      }

      if (reg !== this.register) return;
      const data = res.data.data;
      if (data) {
        this.setRpd(this.bentukRpd(data));
      } else {
        this.dirty = false;
      }
      appModule.sendSuccessNotice("Riwayat Penyakit Terdahulu tersimpan");
    } catch {
      // ErrorAlert sudah ditangani di service
    } finally {
      this.saving = false;
    }
  }
}
